import { render } from "./OutlineButton.vue?vue&type=template&id=5628e6a7"
import script from "./OutlineButton.vue?vue&type=script&lang=js"
export * from "./OutlineButton.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"OutlineButton.vue"]])

export default __exports__